export default __webpack_public_path__ + "static/media/FirefoxDefault.16488fee.png";